import store from '@/store';
import FeatureFlagService from '@/services/FeatureFlagService';
import { FeatureFlag } from '@/models';

export interface FeatureFlagState {
  featureFlags: FeatureFlag[];
}

export const FeatureFlagModule: {
  state: FeatureFlagState,
  mutations: any,
  actions: any,
} = {
  state: {
    featureFlags: [],
  },
  mutations: {
    setFeatureFlags(state: FeatureFlagState, featureFlags: FeatureFlag[]) {
      state.featureFlags = featureFlags;
    },
  },
  actions: {
    async loadFeatureFlags({commit}: any) {
      commit('setFeatureFlags', []);
      const result = await FeatureFlagService.getAllFeatureFlags(store.state.auth.currentUser)
      .catch((error) => {
        throw error;
      });
      commit('setFeatureFlags', result.results);
    },
  },
};
